import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '@insio/ui-toolkit';
import { navigation } from '@/navigation';

interface GdprConsentCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  testId?: string;
}

/** GDPR marketing-communications consent checkbox with a Privacy Policy link. */
export function GdprConsentCheckbox({
  checked,
  onChange,
  testId = 'gdpr-consent'
}: GdprConsentCheckboxProps) {
  const { t } = useTranslation();

  return (
    <div className='flex flex-row items-start gap-sm self-start'>
      <Checkbox
        checked={checked}
        onChange={onChange}
        id={testId}
        className='flex-shrink-0 mt-2xs'
        testId={testId}
      />
      <span className='text-sm text-foreground-muted'>
        {t('features.auth.gdprConsentModal.checkboxPrefix')}
        <Link
          to={navigation.policies('privacy')}
          target='_blank'
          rel='noopener noreferrer'
          className='text-info-text font-medium underline hover:opacity-80'
        >
          {t('features.auth.gdprConsentModal.checkboxLink')}
        </Link>
        {t('features.auth.gdprConsentModal.checkboxSuffix')}
      </span>
    </div>
  );
}
